import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef, useContext } from 'react';
import { MaskedTextInput } from '@paypalcorp/pp-react-masked-text-input';
import { IntlContext, getCurrencyMaskOptions } from '@paypalcorp/pp-react-intl';
var _excluded = ["name", "maskOptions", "prefix", "suffix", "currencyType", "value"];
var CurrencyInput = forwardRef(function (_ref, ref) {
  var name = _ref.name,
      maskOptions = _ref.maskOptions,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      _ref$currencyType = _ref.currencyType,
      currencyType = _ref$currencyType === void 0 ? 'USD' : _ref$currencyType,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var intlContext = useContext(IntlContext);

  var _getCurrencyMaskOptio = getCurrencyMaskOptions(intlContext, maskOptions, currencyType),
      currencyMaskOptions = _getCurrencyMaskOptio.currencyMaskOptions,
      intlCurrencyPrefix = _getCurrencyMaskOptio.intlCurrencyPrefix,
      intlCurrencySuffix = _getCurrencyMaskOptio.intlCurrencySuffix;

  var inputMode = 'decimal';
  var computedValue = value;

  if (currencyMaskOptions) {
    //istanbul ignore next
    if (currencyMaskOptions.scale === 0) {
      inputMode = 'numeric';
    }

    if (computedValue) {
      var _computedValue$split = computedValue.split('.'),
          _computedValue$split2 = _slicedToArray(_computedValue$split, 2),
          wholePart = _computedValue$split2[0],
          fractionalPart = _computedValue$split2[1];

      if (fractionalPart) {
        var fractionValue = fractionalPart.substring(0, currencyMaskOptions.scale);
        computedValue = wholePart + (fractionValue ? '.' + fractionValue : '');
      }
    }
  }

  return /*#__PURE__*/React.createElement(MaskedTextInput, _extends({
    name: name,
    value: computedValue,
    maskOptions: currencyMaskOptions,
    prefix: prefix ? prefix : intlCurrencyPrefix,
    suffix: suffix ? suffix : intlCurrencySuffix,
    inputMode: inputMode,
    ref: ref,
    "data-ppui-info": "currency-input_2.0.29"
  }, rest));
});
export { CurrencyInput };